import { atomWithStorage } from 'jotai/utils';

// initial state
export const favoriteMenuItemKeysAtom = atomWithStorage<string[]>('favoriteMenuItemKeys', []);
